import { render, staticRenderFns } from "./ForeignCurrency.vue?vue&type=template&id=5874035d&scoped=true"
import script from "./ForeignCurrency.vue?vue&type=script&lang=js"
export * from "./ForeignCurrency.vue?vue&type=script&lang=js"
import style0 from "./ForeignCurrency.vue?vue&type=style&index=0&id=5874035d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874035d",
  null
  
)

export default component.exports